import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      nav("/login");
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password of at least 8 characters."
               footer={<Link className="font-semibold text-primary" to="/login">Back to log in</Link>}>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div className="space-y-2">
          <Label htmlFor="token">Reset token</Label>
          <Input id="token" required value={token} onChange={(e) => setToken(e.target.value)}
                 data-testid="reset-token-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" required minLength={8} value={password}
                 onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
        </div>
        {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full rounded-full" data-testid="reset-submit-btn">Update password</Button>
      </form>
    </AuthShell>
  );
}
